module.exports = __webpack_public_path__ + "img/010080.ddb71fe8.png";